<template>
  <v-container class="pa-0">
    <MobileTopPart />
    <v-row>
      <v-col>
        <v-container fluid>
          <v-row>
            <v-col
              cols="12"
              class="pa-5"
            >
              <SearchForm v-if="!$store.state.showArticleOnly" />
            </v-col>
            <v-col
              cols="12"
              style="background: white; padding-bottom: 30px; width: 100%"
            >
              <div
                class="right-col"
                id="content-area"
                style="margin: 0 10px"
              >
                <!-- div
                  v-if="galleriesByArticleId[selectedArticle._id]"
                >
                  <ObjectImages
                    :images="articleImages"
                    :compact="isMobileView"
                    :img-folder="'galleryImages/large'"
                  />
                </div -->
                <div
                  v-html="
                    selectedArticle['contentMobile_' + lang] ||
                    selectedArticle['content_' + lang]
                  "
                />
                <div class="mx-n5 pt-3">
                  <BookingForm v-if="showBookingForm" />
                </div>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
    <v-row>
      <PageFooter />
    </v-row>
  </v-container>
</template>

<script>
import PageFooter from '@/components/App/_PageFooter'
import MobileTopPart from '@/components/Views/Layout/MobileTopPart'
import SearchForm from '@/components/Forms/SearchForm'
import { createHelpers } from 'vuex-map-fields'
import state from '@/store/state'
import sharedComputed from '@/methods/sharedComputed'
import articleComputed from '@/methods/articleComputed'
import sharedMethods from '@/methods/sharedMethods'
import BookingForm from '@/components/Forms/BookingForm'
import ObjectImages from '@/components/ObjectImages/ObjectImages'

const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField',
})

export default {
  name: 'ArticleMobile',

  props: {
    id: {
      type: String,
      default: null,
    },
  },

  components: {
    ObjectImages,
    BookingForm,
    SearchForm,
    MobileTopPart,
    PageFooter,
  },

  created() {
    // When user just came to the side
    // When opening from the menu, is already fine
    if (!this.userJustEntered) {
      return
    }
    setTimeout(() => {
      this.scrollToBeginningOfArticle()
    }, 100)
    setTimeout(() => {
      this.scrollToBeginningOfArticle()
    }, 1000)
  },

  computed: {
    ...mapFields(Object.keys(state)),
    ...sharedComputed,
    ...articleComputed,
  },

  methods: {
    ...sharedMethods,
  },
}
</script>
